import { Component, OnInit } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { ListItem, QualityControlConcrete, RepositoryModal } from '../../../shared'
import { ConcreteComponent } from './concrete.component'

@Component({
    templateUrl: './concrete-modal.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule],
})
export class ConcreteModalComponent extends RepositoryModal<QualityControlConcrete> implements OnInit {
    concreteVendorOptions: ListItem<number | null>[] = []

    ngOnInit() {
        const parentComponent = this.editOptions.initializeParams as ConcreteComponent

        // Build vendor options
        this.concreteVendorOptions = []
        this.concreteVendorOptions.push(new ListItem<number | null>(null, 'Select a Supplier'))
        parentComponent.concreteVendors.forEach(x => {
            this.concreteVendorOptions.push(new ListItem<number | null>(x.id, x.name))
        })

        if (this.isAdding) {
            // Set default job from parent
            this.target.job = parentComponent.selectedJob()
        }
    }

    protected onBeforeSave(): boolean {
        if (!this.target.job) {
            this.services.notification.warning('Job is required')
            return false
        }
        return true
    }
}
